import { groupBy, map } from 'lodash';
import { useFind } from 'api/APIHooks';
import { useCurrentPayerId } from 'common/contexts/CurrentProviderContext';

const useContractedProgramOptions = () => {
  const payerId = useCurrentPayerId();
  let contractedProgramOptions = [];
  const { isSuccess: isContractedProgramsSuccess, data: contractedProgramsData } = useFind(
    'fee_schedule_program',
    { 'fee_schedule.payers': payerId },
    {
      queryConfig: {
        enabled: !!payerId,
        placeholderData: undefined,
      },
      page: {
        size: Infinity,
      },
    },
  );

  if (isContractedProgramsSuccess) {
    const feeSchedulePrograms = contractedProgramsData.data.data;
    // NOTE: Group programs by name to handle duplicates
    const programsGroupedByName = groupBy(feeSchedulePrograms, 'name');
    contractedProgramOptions = map(programsGroupedByName, (programsWithSameName, programName) => ({
      label: programName,
      value: map(programsWithSameName, 'id').join(','),
    }));
  }

  return contractedProgramOptions;
};

export default useContractedProgramOptions;
